import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const usertoken = localStorage.getItem("token");

  if (!usertoken) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
